export default __webpack_public_path__ + "static/media/avatar.65373d7a.png";